module.exports = __webpack_public_path__ + "site_static/img/vip-pic.7873c5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneimg/vip-pic.jpg
// module id = +xp7
// module chunks = 0